
credentialsFactory.$inject = ['$rootScope'];

export function credentialsFactory($rootScope) {
  'use strict';
  // object must stay in sync with app.credentials
  var credentialsService = {};

  function sync() {
    var prop;

    // empty service
    for (prop in credentialsService) {
      if (credentialsService.hasOwnProperty(prop)) {
        delete credentialsService[prop];
      }
    }

    // copy properties
    /* global app */
    for (prop in window.app.credentials) {
      if (window.app.credentials.hasOwnProperty(prop)) {
        credentialsService[prop] = window.app.credentials[prop];
      }
    }
  }

  // stay in sync
  $rootScope.$watch(
    function() {
      return window.app.credentials;
    },
    function() {
      sync();
    }
  );

  // first sync
  sync();

  // return service
  return credentialsService;
}